import { PropaneTank } from '@mui/icons-material'
import { ApplianceConfigStorageTank } from './Appliance'
import { StrategySliders } from '../../components/StrategySliders'
import { TemperatureRelayAppliance } from './TemperatureRelayAppliance'
import { CustomSwitch } from '../../components/atoms/CustomSwitch'
import { Trans } from 'react-i18next'

export class StorageTankAppliance extends TemperatureRelayAppliance<ApplianceConfigStorageTank> {
  get Icon() {
    return PropaneTank
  }

  getDefaultConfig(): ApplianceConfigStorageTank {
    return Object.assign({
      advanced: false,
      strategy: 'MANUAL',
      plan_by_price: true,
      domestice_water: true,
      pv_priority: 6,
      saving_or_heat: 0,
      heat_preservation: 24,
      fixed_percentage: 40,
    }, super.getDefaultConfig())
  }

  drawSwitches(): React.ReactNode {
    return <>
      <CustomSwitch
        data-cy="switch-HotWater"
        onClick={() => this.setConfig('domestice_water', !this.getConfig('domestice_water'))}
        checked={this.getConfig('domestice_water')}
      /><Trans>This boiler heats also domestic hot water.</Trans>
    </>
  }

  drawSliders(): React.ReactNode {

    return (
      <StrategySliders
        notify={this.app.t('This appliance type is for house heating. If you want to add domestic hot water heater, add Boiler appliance instead.')}
        key="sliders"
        name1="saving_or_heat"
        slider1={[this.app.t('More Saving'), this.app.t('More Heat')]}
        values1={[-100, 100]}
        value1={this.getConfig('saving_or_heat')}
        title1={this.app.t('Do you prefer?')}

        name2="heat_preservation"
        slider2={['4h', '24h']}
        values2={[4, 24]}
        value2={this.getConfig('heat_preservation')}
        title2={this.app.t('Time window of optimization?')}

        onChange={(k, v) => { this.setConfig(k, v); this.applyConfig() }}
      />
    )
  }

  convert() {
    const ctrl = this.getOptimizerControl()
    const advanced = this.getConfig('advanced')

    return Object.assign({
      min_duty: advanced ? ctrl.getConfig('min_duty') : (this.getConfig('domestice_water') ? 20 : 0),
      max_duty: advanced ? ctrl.getConfig('max_duty') : Math.round((this.getConfig('saving_or_heat') as number) < 0 ? 92 + 0.17 * (this.getConfig('saving_or_heat') as number) : 92 + 0.08 * (this.getConfig('saving_or_heat') as number)),
      min_duty_at: advanced ? ctrl.getConfig('min_duty_at') : Math.round(16 + 0.02 * (this.getConfig('saving_or_heat') as number)),
      max_duty_at: advanced ? ctrl.getConfig('max_duty_at') : Math.round((this.getConfig('saving_or_heat') as number) < 0 ? -30 : -30 + 0.05 * (this.getConfig('saving_or_heat') as number)),
      time_constant: (this.getConfig('heat_preservation') as number),
    }, super.convert())
  }
}
